export default "__VITE_ASSET__A6qqyAQW0zWGfSOXFG877Q__"